import clsx from 'clsx'

interface EnrichmentStatusTagProps {
  status: 'succeeded' | 'failed' | 'pending' | null | undefined
  className?: string
}

/** Readonly outcome badge for LLM contextual enrichment. */
export default function EnrichmentStatusTag({ status, className }: EnrichmentStatusTagProps) {
  if (status === 'pending') {
    return (
      <span
        className={clsx(
          'inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium border',
          'bg-gray-500/10 text-gray-400 border-gray-600/40',
          className
        )}
        title="Background LLM enrichment in progress"
      >
        enriching…
      </span>
    )
  }

  if (status === 'succeeded') {
    return (
      <span
        className={clsx(
          'inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium border',
          'bg-teal-500/15 text-teal-300 border-teal-500/30',
          className
        )}
        title="LLM contextual enrichment succeeded"
      >
        enriched
      </span>
    )
  }

  if (status === 'failed') {
    return (
      <span
        className={clsx(
          'inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium border',
          'bg-gray-500/15 text-harbor-text-secondary border-gray-500/30',
          className
        )}
        title="LLM enrichment failed; indexed with static breadcrumbs"
      >
        enrichment failed
      </span>
    )
  }

  return null
}
